import React, { useState, useEffect } from 'react';
import cn from 'classnames';
import { CUSTOM_MESSAGES, LABEL } from '../../veriables';
import { getObjectValue } from '@utility/utills';
import style from './orders.module.css';
import { reverse } from 'lodash';
import KioskConfirmatioPopUp from '@components/checksCommon/kioskConfirmationPopUp';
import Modal from '@components/common/Modal';
import OpenPopUp from './openPopup';

const KioskCart = (props) => {
  const [pendingItems, setPendingItems] = useState([]);
  const [subTotalAmount, setSubTotalAmount] = useState(0);
  const [cardIndex, setCardIndex] = useState([]);
  const [currentModifiers, setCurrentModifiers] = useState([]);
  const [isConfirmation, setIsConfirmation] = useState(false);
  const [cartItemDetails, setCartItemDetails] = useState(null);
  const { seat, isFinalise } = props;
  const [isDiscountPopUp, setIsDiscountPopup] = useState(false);
  const [selected, setSelected] = useState('');
  const [isOpenPopUp, setIsOpenPopUp] = useState(false);

  useEffect(() => {
    let subTotalAmt = 0;
    const cartItems = props.cart.length > 0 ? props.cart.reduce((a, v) => {
      if (v.pending && v.itemType !== 'D') {
        a.push({
          ...v,
        });
        subTotalAmt += (v.quantity * v.price);
      }
      return a;
    }, []) : [];
    setSubTotalAmount(subTotalAmt);
    setPendingItems(reverse(cartItems));
  }, [props.cart]);

  const handleSelection = (item) => {
    if (item.open && (item.discountType === 1 || item.discountType === 2)) {
      setIsOpenPopUp(true);
    }
    setSelected(`${item.id}`);
  };

  const validate = (data) => {
    let errorMessage = {};
    return new Promise((resolve, reject) => {
      if (!data.discount) {
        errorMessage = { ...errorMessage, message: 'Discount cannot be empty' };
        reject(errorMessage);
      } else if (data.discount && props.discounts.find((e) => e.id === Number(selected)).discountType === 1 && (Number(data.discount) === 0 || Number(seat.subTotalAmount) < Number(data.discount))) {
        errorMessage = { ...errorMessage, message: 'Discount should be more than zero and not exceed sub total' };
        reject(errorMessage);
      } else if (data.discount && props.discounts.find((e) => e.id === Number(selected)).discountType === 2 && (Number(data.discount) === 0 || Number(data.discount) > 100)) {
        errorMessage = { ...errorMessage, message: 'Discount should be more than zero and not exceed 100 %' };
        reject(errorMessage);
      } else {
        resolve();
      }
    });
  };

  const handleApplyDiscount = (data) => {
    setIsDiscountPopup(false);
    const discount = props.discounts.find((e) => e.id === Number(selected));
    const seatIds = props.seat.seats.filter((d) => d.open);
    const dataToSend = {
      storeId: props.deviceInfo.storeId,
      deviceId: props.deviceInfo.deviceId,
      employeeId: props.userInfo.id,
      checkHeaderId: props.seat.id,
      employeeCard: getObjectValue(() => JSON.parse(window.sessionStorage.getItem('userInfo')).employeeCard, null),
      discounts: [
        {
          quantity: 1,
          discountId: discount.id,
          discountName: discount.name,
          value: data?.discount,
          pending: true,
          seatIds: [
            seatIds[0].id
          ],
          internalId: new Date().getTime(),
          modifierData: [],
          modifierJson: null
        }
      ],
      orderJson: 'ui-populated-data',
      longitude: '0',
      latitude: '0',
      geoLocation: '0'
    };
    props.applyDiscountForCounter(dataToSend);
  };

  const deleteDiscount = () => {
    const discountItem = seat?.orders?.[0]?.items?.length > 0 && seat.orders[0].items?.find((e) => e.itemType === 'D');
    const dataToSend = {
      storeId: props.deviceInfo.storeId,
      deviceId: props.deviceInfo.deviceId,
      employeeId: props.userInfo.id,
      checkHeaderId: props.seat.id,
      employeeCard: getObjectValue(() => JSON.parse(window.sessionStorage.getItem('userInfo')).employeeCard, null),
      discounts: [
        {
          checkOrderItemId: discountItem.id,
          orderSendMode: 0
        }
      ]
    };
    props.handleDiscountDelete(dataToSend);
  };

  const handleItems = (item, isSelect) => {
    setCardIndex([]);
    setCurrentModifiers([]);
    const foundIndex = pendingItems.findIndex((x) => x.id === item.id);
    pendingItems[foundIndex] = { ...item, isCheck: isSelect };
    setPendingItems([...pendingItems]);
  };
  const handleCartSelection = (node, index, id) => {
    if (cardIndex.indexOf(`${node}${index}${id}`) === -1) {
      setCardIndex(`${node}${index}${id}`);
    } else {
      setCardIndex([]);
    }
  };
  const handleShowModifiers = (id) => {
    if (currentModifiers.indexOf(`${id}`) === -1) {
      setCurrentModifiers(currentModifiers.concat(`${id}`));
    } else {
      setCurrentModifiers(currentModifiers.filter((x) => x !== `${id}`));
    }
  };
  const renderModifier = (modifiersObj) => (
    <div className={cn('pl-2')}>
      {modifiersObj && modifiersObj.map((modifier) => {
        if (modifier.modifiers && modifier.modifiers.length === 1 && getObjectValue(() => !modifier.modifiers[0].modifierGroupId, false)) {
          return (
            <div key={modifier.id} className="fs-14 fw-500">
              {modifier.modifiers[0].quantity > 1 && (<span className={cn('badge badge-warning ml-1 va-tt')}>{modifier.modifiers[0].quantity} &times;</span>)}
              {modifier.modifierName}
              {modifier.quantity > 1 && (<span className="badge badge-warning ml-1 va-tt">&times; {modifier.quantity}</span>)}
              {modifier.price ? (<small className="text-muted od-text-muted ml-1">{LABEL().CURRENCY_SYMBOL}{modifier.price.toFixed(2)}</small>) : ''}
            </div>
          );
        }
        return (
          <div key={modifier.id} className="fs-14 fw-500">
            {modifier.quantity > 1 && <span className={cn('badge badge-warning ml-1 va-tt')}>{modifier.quantity} &times;</span>}
            {modifier.modifierName}
            {modifier.price ? (<small className="text-muted od-text-muted ml-1">{LABEL().CURRENCY_SYMBOL}{modifier.price.toFixed(2)}</small>) : ''}
            {(modifier.note || modifier.comment) && <div className="pl-2">{modifier.note || modifier.comment}</div>}
            {modifier.modifiers && modifier.modifiers.length > 0 && (
              renderModifier(modifier.modifiers)
            )}
          </div>
        );
      })}
    </div>
  );

  const cardButtons = [
    { key: 'edit', displayName: LABEL().EDIT },
    { key: 'delete', displayName: LABEL().DELETE },
    { key: 'unsentRepeat', displayName: LABEL().REPEAT }
  ];

  const isPackItem = (item) => {
    const menuItemsHashTable = JSON.parse(window.sessionStorage.getItem('menuItemsHashTable')) || {};
    return menuItemsHashTable?.[item?.menuItemId]?.pack || menuItemsHashTable?.[item?.menuItemId]?.cardType === 1;
  };

  const handleButtonClick = (type, data) => {
    if (type === 'edit') {
      props.onModifyItem({ ...data, ...JSON.parse(data.modifierJson) }, 'edit');
    } else if (type === 'payment') {
      props.handleRoute();
    } else {
      setIsConfirmation(true);
      setCartItemDetails({ type, data });
    }
  };

  const onClose = (type) => {
    if (type === 'yes') {
      switch (cartItemDetails.type) {
        case 'delete':
        case 'delete selected':
        case 'delete all': props.deleteItem(cartItemDetails.data); break;
        case 'unsentRepeat': props.handleRepeatData(cartItemDetails.data, 'unsent'); break;
        case 'send selected':
        case 'send all': props.checkOut(cartItemDetails.data); break;
        case 'edit': props.onModifyItem({ ...cartItemDetails.data, ...JSON.parse(cartItemDetails.data.modifierJson) }, 'edit'); break;
        default:
          break;
      }
      setIsConfirmation(false);
    } else {
      setIsConfirmation(false);
    }
  };

  return (
    <div className={cn('h-100 border od-container-card-border border-color-primary roundedSm')}>
      {/* <div className="col-12 fw-600 px-1 h-5 row mx-0 text-uppercase od-text-primary text-primary justify-content-center">
        <div className="col-1 p-0 row mx-0 align-items-center d-none">
          <input
            type="checkbox"
            id="sent"
            onChange={() => {}}
            className={cn(style.checkbox, pendingItems.length === 0 && 'd-none')}
            onClick={(e) => handleSelectAll(e.target.checked)}
            checked={pendingItems.filter((e) => e.isCheck).length === pendingItems.length || false}
          />
        </div>
        <div className="col-11 px-1 text-center">{LABEL().CART}</div>
      </div> */}
      {(!seat || pendingItems.length === 0) && (
        <div className="h-90 d-flex od-text-primary justify-content-center align-items-center fs-12 fw-600 pt-1 overflowY" style={{ maxheight: '80%' }}>{LABEL().NO_ITEMS_ADDED}</div>
      )}
      {pendingItems && pendingItems.length > 0 && (
        <div className={cn(!isFinalise && seat.discountAmount > 0 ? 'h-85' : 'h-90', 'p-1 overflowY')}>
          {pendingItems && pendingItems.length > 0 && pendingItems.map((item, index) => {
            return (
            // <SwipeCards
            //   containerClass={cn('p-1 position-relative', cardIndex.includes(`${index}${item.id}`) ? 'border border-color-secondary od-container-card-background  background-secondary rounded' : 'border background-primary od-app-background-color od-container-card-border rounded border-color-primary rounded')}
            //   onRightDrag={() => handleButtonClick('delete', [item])}
            //   isRightDrag
            //   isLeftDrag
            //   onLeftDrag={() => handleButtonClick('edit', item)}
            //   index={index}
            // >
              <>
                {item.menuItemName && (
                <div key={item.id} className={cn(item.isProcessing ? 'od-check-unsent-background' : '', 'p-1 my-1 border od-container-card-border border-color-primary roundedSm')}>
                  <div className={cn('row m-0 position-relative justify-content-center align-items-center fs-12')}>
                    <div className="col-1 p-0 row mx-0 align-items-center d-none">
                      <input
                        type="checkbox"
                        id={item.id}
                        onChange={() => {}}
                        className={cn(style.checkbox)}
                        onClick={(e) => handleItems(item, e.target.checked)}
                        checked={item.isCheck || false}
                      />
                    </div>
                    <div role="presentation" className="col-11 od-text-primary row m-0 p-1" onClick={() => { handleCartSelection(index, item.id); }}>
                      <div className={cn('fw-500 fs-12 p-0 col-6')}>{item.menuItemName}</div>
                      <div
                        className="col-2 text-right p-0 od-text-primary text-primary"
                        role="presentation"
                        onClick={(e) => {
                          if (item.modifiers && item.modifiers.length > 0) {
                            e.stopPropagation();
                            handleShowModifiers(item.id);
                          }
                        }}
                      >
                        {item.modifiers && item.modifiers.length > 0 && (
                          currentModifiers.includes(`${item.id}`) ? (
                            <i
                              className={cn('fa fa-angle-double-up fs-12')}
                              aria-hidden="true"
                            />
                          ) : (
                            <i
                              className={cn('fa fa-angle-double-down fs-12')}
                              aria-hidden="true"
                            />
                          )
                        )}
                      </div>
                      <div className={cn('col-1 fs-12 text-right fw-500 p-0')}>{item.quantity}</div>
                      {<div className="col-3 fs-12 fw-500 p-0 text-right">{LABEL().CURRENCY_SYMBOL}{item?.price?.toFixed(2)}</div>}
                    </div>
                  </div>
                  <div className="col-11 offset-1 od-text-primary px-2">
                    {item.modifiers && item.modifiers.length > 0 && currentModifiers.includes(`${item.id}`) && renderModifier(item.modifiers)}
                    {(cardIndex.includes(`${index}${item.id}`) || currentModifiers.includes(`${item.id}`)) && (item.note || item.comment) && <div className="col-12 text-left pl-2 px-0">{item.note || item.comment}</div>}
                  </div>
                  {cardIndex.includes(`${index}${item.id}`) && (
                  <div className="row m-0 pt-3 pb-1 justify-content-center">
                    {cardButtons && cardButtons.map((btn) => {
                      const isEditDisabledForPack = btn.key === 'edit' && isPackItem(item);
                      return (
                        <div key={btn.key} className="p-1 col-6">
                          <button
                            type="button"
                            className={cn('w-100 fs-14 btn-ripple rounded btn20 btn fw-600')}
                            onClick={() => { if (!isEditDisabledForPack) handleButtonClick(btn.key, btn.key === 'edit' ? item : [item]); }}
                            disabled={isEditDisabledForPack}
                            style={isEditDisabledForPack ? { cursor: 'not-allowed', background: 'rgb(177,177,177)' } : {}}
                          >
                            {btn.displayName}
                          </button>
                        </div>
                      );
                    })}
                  </div>
                  )}
                </div>
                )}
              </>
            // </SwipeCards>
            );
          })}
        </div>
      )}
      <div className={cn('row mx-0 px-1 h-10 od-text-primary text-primary p-1', !isFinalise && seat.discountAmount > 0 ? 'h-15' : 'h-10')}>
        {!isFinalise && seat.discountAmount > 0 && (
        <div className="col-12 m-0 w-100 d-flex px-1">
          <div className="col-11 p-0 fs-20 fw-600 text-center">{LABEL().DISCOUNT} {LABEL().CURRENCY_SYMBOL}{seat.discountAmount.toFixed(2)}</div>
          <div className="col-1 p-0"><i role="presentation" onClick={() => deleteDiscount()} className="fa fa-trash" aria-hidden="true" /></div>
        </div>
        )}
        {!isFinalise && subTotalAmount.toFixed(2) > 0 && (
          <>
            {(seat.discountAmount <= 0) && (
            <div className="col-3 m-0 fs-20 p-1">
              <button
                type="button"
                className={cn('w-100 fs-14 btn-primary btn-ripple rounded btn20 btn od-btn-primary fw-600')}
                onClick={() => { setIsDiscountPopup(true); setSelected(''); }}
              >
                % / {LABEL().CURRENCY_SYMBOL}
              </button>
            </div>
            )}
            <div className={cn('d-flex justify-content-center m-0 fs-20 p-1', (seat.discountAmount <= 0) ? 'col-9' : 'col-12')}>
              {/* <div className="col-3 text-left fw-600">{LABEL().TOTAL}</div> */}
              <div className="fw-600 text-center">{LABEL().TOTAL} {LABEL().CURRENCY_SYMBOL}{(Number(seat.totalAmount)).toFixed(2)}</div>
            </div>
          </>
        )}
      </div>
      {isConfirmation && (
        <KioskConfirmatioPopUp
          isOpen={isConfirmation}
          onClose={onClose}
          type={cartItemDetails.type}
          data={cartItemDetails.data}
        />
      )}
      {isDiscountPopUp && (
      <Modal
        isOpen={isDiscountPopUp}
        isModalCenter
        loading={props.loading}
        // customClass2={styles.maxWidth}
      >
        <div className="p-2 justify-content-center align-items-center text-center">
          <div className={cn('px-1 text-right')}>
            <i
              role="presentation"
              className={cn('fa fa-times fs-24')}
              onClick={() => setIsDiscountPopup(!isDiscountPopUp)}
            />
          </div>
          {Object.values(props.discounts).length > 0 ? (
            <div className="fs-24 fw-600 text-center px-0 py-2 h50vh overflowY overflowXHidden">
              {Object.values(props.discounts)?.map((item) => {
                return (
                  <div role="presentation" key={item.id} className={cn(selected.includes(item.id) ? 'bgGreen' : '', 'card my-2 py-2 col-12 text-center')} onClick={() => handleSelection(item)}>
                    {item.name}
                  </div>
                );
              })}
            </div>
          ) : (
            <div className="fs-24 fw-600 text-center px-0 py-2 h-100 overflowY overflowXHidden">
              {CUSTOM_MESSAGES().NO_DISCOUNTS}
            </div>
          )}
          <div className="col-12 row mx-0 px-0 py-3 justify-content-center align-items-center">
            <div className="col-12 px-1">
              <button disabled={!selected} className="w-100 btn btn100 btn-primary btn-ripple od-btn-primary fs-14" type="button" onClick={() => { setIsDiscountPopup(!isDiscountPopUp); handleApplyDiscount(); }}>
                <div className="fs-30">{LABEL().APPLY}</div>
              </button>
            </div>
          </div>
        </div>
      </Modal>
      )}
      {isOpenPopUp && (
        <Modal
          isOpen={isOpenPopUp}
          isModalCenter
          loading={props.loading}
        >
          <div className="p-2 justify-content-center align-items-center text-center">
            <div className={cn('px-1 text-right')}>
              <i
                role="presentation"
                className={cn('fa fa-times fs-24')}
                onClick={() => setIsOpenPopUp(!isOpenPopUp)}
              />
            </div>
            <OpenPopUp isOpen={isOpenPopUp} discounts={props.discounts} validate={validate} onSubmit={handleApplyDiscount} selected={selected} isOpenPopUp={isOpenPopUp} setIsOpenPopUp={setIsOpenPopUp} />
          </div>
        </Modal>
      )}
    </div>
  );
};

export default KioskCart;
